import { defineStore } from "pinia";
import { updateNotarial as updateNotarialApi } from "../api";

export const useNotarialStore = defineStore("notarial", {
  state: () => ({
    isSaving: false,
    isSaved: false,
  }),
  actions: {
    async saveNotarial(uuid, payload, isNotifyDisabled) {
      this.isSaving = true;
      this.isSaved = false;

      try {
        const data = await updateNotarialApi(uuid, payload, isNotifyDisabled);
        this.isSaved = true;
        return data;
      } finally {
        this.isSaving = false;
      }
    },
    resetFlags() {
      this.isSaving = false;
      this.isSaved = false;
    },
  },
});
